import { OFFICE_EXTENSIONS } from "../constants";

export function isHttpUrl(value = "") {
  try {
    const url = new URL(String(value));
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
}

export function isImageUrl(url = "") {
  const cleanUrl = String(url || "").split("?")[0];
  return /\.(png|jpe?g|webp|gif|svg)$/i.test(cleanUrl);
}

export function getFileName(url = "") {
  try {
    const cleanUrl = decodeURI(String(url));
    return cleanUrl.split("?")[0].split("#")[0].split("/").pop() || "file";
  } catch {
    return String(url).split("?")[0].split("#")[0].split("/").pop() || "file";
  }
}

export function fileExt(url = "") {
  const fileName = getFileName(url);
  const match = fileName.match(/\.([a-z0-9]+)$/i);
  return match ? match[1].toLowerCase() : "";
}

export function getMicrosoftOfficeViewerUrl(url) {
  return `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
    url,
  )}`;
}

export function getGooglePdfViewerUrl(url) {
  return `https://docs.google.com/viewer?url=${encodeURIComponent(
    url,
  )}&embedded=true`;
}

export function getFilePreviewUrl(url) {
  const ext = fileExt(url);

  if (OFFICE_EXTENSIONS.includes(ext)) {
    return getMicrosoftOfficeViewerUrl(url);
  }

  if (ext === "pdf") {
    return getGooglePdfViewerUrl(url);
  }

  return url;
}

export function normalizeFileItems(rawValue) {
  const files = Array.isArray(rawValue) ? rawValue : rawValue ? [rawValue] : [];

  return files
    .map((file) => {
      if (!file) return null;

      if (typeof file === "string") {
        return {
          url: file,
          name: getFileName(file),
          ext: fileExt(file),
        };
      }

      const url =
        file.url ||
        file.fileUrl ||
        file.fileURL ||
        file.path ||
        file.location ||
        file.secure_url ||
        file.downloadUrl ||
        file.href ||
        file.name;

      if (!url) return null;

      return {
        url,
        name:
          file.originalname ||
          file.originalName ||
          file.filename ||
          file.fileName ||
          file.name ||
          getFileName(url),
        ext: fileExt(url),
      };
    })
    .filter(Boolean);
}
